module.exports = __webpack_public_path__ + "img/me.7fcbadba.jpg";